module.exports = __webpack_public_path__ + "d5af98db3e4fa9fe0d2c5f25e4df0b50.MP3";